module.exports = __webpack_public_path__ + "static/iastate.25485ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/iastate.png
// module id = 2184
// module chunks = 61762850755587